export class DetalleCargaLiquid {
    idcargaliq?:number;
    idliquida?:any;
    salida_carga?:number;
    entrada_carga?:number;
    pres_devo?:number;
    viaje?:number;
    idproduct?:any;

    constructor(){}
}
